import { TileCounts } from '../hand';
import { detectYakuCandidates, WinContext, YakuResult } from './yaku';
import { computeFu, computeChiitoitsuFu } from './fu';
import { computeScore, Payment } from './score';

export interface ScoreContext extends WinContext {
  isDealer: boolean;
  doraCount: number;
}

export interface WinResult {
  yaku: YakuResult[];
  han: number;     // 役 + 도라 합산
  fu: number;
  yakuman: boolean;
  payment: Payment;
  valid: boolean;  // 役이 하나라도 있어야 true
}

export function scoreWin(counts: TileCounts, ctx: ScoreContext): WinResult {
  const candidates = detectYakuCandidates(counts, ctx).filter((cand) => cand.yaku.length > 0);

  // 役이 없으면 화료 불가 (도라는 役이 아님)
  if (candidates.length === 0) {
    return { yaku: [], han: 0, fu: 0, yakuman: false, payment: { total: 0 }, valid: false };
  }

  let best: WinResult | null = null;
  for (const cand of candidates) {
    const fu = cand.parse === null
      ? (cand.yakuman ? 0 : computeChiitoitsuFu())
      : computeFu({ parse: cand.parse, ctx, yaku: cand.yaku, isConcealed: true });
    const han = cand.yakuman ? cand.han : cand.han + ctx.doraCount;
    const payment = computeScore({ han, fu, isDealer: ctx.isDealer, isTsumo: ctx.isTsumo });

    const yaku = [...cand.yaku];
    if (!cand.yakuman && ctx.doraCount > 0) {
      yaku.push({ key: 'dora', name: '도라', han: ctx.doraCount });
    }
    const result: WinResult = { yaku, han, fu, yakuman: cand.yakuman, payment, valid: true };
    if (best === null || isBetter(result, best)) best = result;
  }
  return best as WinResult;
}

/** 점수 우선 비교: 역만 우선 → 총점 → 판 → 후. */
function isBetter(a: WinResult, b: WinResult): boolean {
  if (a.yakuman !== b.yakuman) return a.yakuman;
  if (a.payment.total !== b.payment.total) return a.payment.total > b.payment.total;
  if (a.han !== b.han) return a.han > b.han;
  return a.fu > b.fu;
}
